export default "__VITE_ASSET__CZfjyBlK__"